/* eslint-disable1 */
// FWSD-5216 - video DOMException: play() failed because the user didn't interact with the document first
// To make the video autoplay on html 5 elements work after the chrome 66 update you just need to add the muted property to the video element.
// https://developer.chrome.com/blog/autoplay/ - Autoplay policy in Chrome
// https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide - Autoplay and autoplay blocking
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ReactBootstrapSlider from 'react-bootstrap-slider'
import { Button, Dropdown } from 'react-bootstrap'
import classnames from 'classnames'
import axios from 'axios'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import { toastr } from 'react-redux-toastr'
import { isMobileOnly } from 'react-device-detect'
import _ from 'lodash'
import $ from 'jquery'
import Select from 'react-select'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"
import { useTranslation } from 'react-i18next'

momentDurationFormatSetup(moment)

import SimpleMapExampleGoogleMap from '../../AdvancedPlayer/SimpleMapExampleGoogleMap'
import SimpleMapExampleHEREMap from '../../AdvancedPlayer/SimpleMapExampleHEREMap'
import OverlayTriggerNode from '../../AdvancedPlayer/OverlayTriggerNode'
import Controls from '../../Controls'
// import GsensorGraph from '../../common/AdvancedPlayer/GsensorGraph'

import { getDirection } from '../../helpers/labels'
import { addAuditLogFunc } from '../../helpers/helperAuditLog'
import { eventTypeDetection } from '../../helpers/helperEvents'
import { apiCallGet } from '../../../action/RouterActions'
import { getUserInfo } from '../../../action/ClientActions';
import { getEventById } from '../../../action/AlertActions';

import { driverIcon, eventIcons, moreActionsIcon, videoPlayerIcons } from '../../helpers/iconHelpers';
import CustomButton from '../../CustomButton'
import { isInternalUser } from '../../helpers/constants'

import 'bootstrap-slider/dist/css/bootstrap-slider.css'
import '../webplayer/webplayer.sass'
import './AdvancedPlayerPermalink.sass'

let vid1, vid2, vid3, vid4;

const vidDeviationControl = () => {
	if (
		(!vid2.ended && Math.abs(vid1.currentTime - vid2.currentTime) > 0.2)
		|| (vid3 && !vid3.ended && Math.abs(vid1.currentTime - vid3.currentTime) > 0.2)
		|| (vid4 && !vid4.ended && Math.abs(vid1.currentTime - vid4.currentTime) > 0.2)
	) {
		cancelAnimationFrame(vidDeviationControl);

		$('#player-video video').each(function () {
			this.pause();
		});

		// set all 3 before new AnimationFrame is drawn.
		if (vid4) {
			vid4.currentTime = vid1.currentTime;
			vid3.currentTime = vid4.currentTime;
			vid2.currentTime = vid3.currentTime;
			vid1.currentTime = vid2.currentTime;
		} else if (vid3) {
			vid3.currentTime = vid1.currentTime;
			vid2.currentTime = vid3.currentTime;
			vid1.currentTime = vid2.currentTime;
		} else {
			vid2.currentTime = vid1.currentTime;
			vid1.currentTime = vid2.currentTime;
		}

		$('#player-video video').each(function () {
			this.play();
		});
	}

	if (vid1.paused || vid1.ended) {
		cancelAnimationFrame(vidDeviationControl);
		return;
	}
	else {
		requestAnimationFrame(vidDeviationControl);
	}
}

const PermalinkVideo = (props) => {
	const { params, videoUrls, nvrUrl, metadatasUrl, driver, toggleLoader } = props;
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'permalinksPage.permalinkVideo' });
	const [intervalPlayback, setIntervalPlayback] = useState(null);

	const [windowHeight, setWindowHeight] = useState(560);
	const [windowWidth, setWindowWidth] = useState(900);
	// const [parentObj, setParentObj] = useState(null);
	const [metadata, setMetadata] = useState([]);
	const [header, setHeader] = useState({});
	const [maxCollection, setMaxCollection] = useState();
	const [coordinates, setCoordinates] = useState({ lat: -34.397, lng: 150.644 });
	const [direction, setDirection] = useState(0);
	const [dir, setDir] = useState('');
	// const [starttimestamp, setStarttimestamp] = useState('');
	// const [timestamp, setTimestamp] = useState(0);
	// const [userRole, setUserRole] = useState();
	const [event, setEvent] = useState({});
	const [state, setState] = useState({
		starttimestamp: '',
		timestamp: 0,
	});
	const [polyline, setPolyline] = useState([]);
	const [acc, setAcc] = useState([]);
	const [speed, setSpeed] = useState(0);
	const [meye, setMeye] = useState({
		"error": false,
		"failsafe": false,
		"fcw": false,
		"hw": 0,
		"hwWarning": 0,
		"ldw": true,
		"ldwLeft": false,
		"ldwRight": false,
		"pedDz": false,
		"pedForward": false,
		"speedWarning": 0,
		"tamper": false
	});
	const [activeChannel, setActiveChannel] = useState(1);
	const [channelAudio, setChannelAudio] = useState(2);
	const [play, setPlay] = useState(false);
	const [playbackRate, setPlaybackRate] = useState(1.0);
	const [fps, setFps] = useState(24);
	const [value, setValue] = useState(0);
	const [max, setMax] = useState(null);
	const [speedUnit, setSpeedUnit] = useState('MPH');

	const [volume_value, setVolume_value] = useState(0.5);
	const [videos, setVideos] = useState([
		{ brightness: 1, contrast: 1, audio: false },
		{ brightness: 1, contrast: 1, audio: false },
		{ brightness: 1, contrast: 1, audio: false },
		{ brightness: 1, contrast: 1, audio: false },
	]);
	const [showChannelsSelection, setShowChannelsSelection] = useState(false);
	const [showTooltipDoubleClick, setShowTooltipDoubleClick] = useState(false);
	const [single_active_player, setSingle_active_player] = useState(false);
	const [showZoomControls, setShowZoomControls] = useState(false);

	useEffect(() => {
		getUserInfo()
			.then(async (res) => {
				const user = await res.data.response.user;
				const pos = metadatasUrl.lastIndexOf("/");
				const data = {
					user_role: user.roles[0],
					partner_name: user.partner_company_name,
					company_name: user.company_name,
					event_id: metadatasUrl.substring(metadatasUrl.substring(0, pos).lastIndexOf("/") + 1, pos),
				}

				await getEventById(data)
					.then((res) => { setEvent(res.data.response.event) })
					.catch((err) => { console.log('getEventById error: ', err) })
			})
			.catch((error) => {
				console.log('!getUserInfo componentWillMount error: ', error.response, error);
			});

		//* Only for iOS devices display channel selection to playback video because they can not to mutiple playback
		if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
			setShowChannelsSelection(true)
			setActiveChannel(2)
		}
		// ******

		toggleLoader(true)
		setWindowWidth(window.innerWidth - window.innerWidth * 0.2)
		setWindowHeight(window.innerHeight - window.innerHeight * 0.2)

		let maxCollection = []
		let playersLoaded = 0;

		// $('#player-video video').on('loadedmetadata', function(e){
		$('#player-video video').on('loadeddata', (e) => {
			if (hasAudio(e.target)) {
				const channelNumber = $(e.target).attr("data-channel")
				let videosUpdate = videos;
				videosUpdate[channelNumber - 1].audio = true
				setVideos(videosUpdate)
			}

			maxCollection.push({ videoObj: e.target, duration: e.target.duration });
			playersLoaded++;
			if (playersLoaded === videoUrls.length) {
				setMaxCollection(maxCollection);
				setPlayerEvents(maxCollection);
			}
		});
		axios(metadatasUrl)
			.then((res, err) => {
				console.log('metadata.json res', res);

				let polyline = []
				let acc = []
				let metadata = res.data.metadata

				metadata = _.orderBy(metadata, ['t']);

				const entry = _.find(res.data.metadata, function (item, i) {
					return item.gps && item.gps.lat && item.gps.lon;
				})

				//            res.data.metadata.map((item, i) => {
				metadata.map((item, i) => {
					if (item.gps && item.gps.lat && item.gps.lon) {
						polyline.push({ "lat": item.gps.lat, "lng": item.gps.lon });
					}

					if (item.acc) {
						acc.push(item.acc);
					}
				});
				acc = _.orderBy(acc, ['t']);

				setHeader(res.data.header) // res.data.header
				setMetadata(metadata) // res.data.metadata
				setPolyline(polyline)
				setAcc(acc)
				setState((prevState) => ({
					starttimestamp: (res.data?.header?.date && res.data?.header?.startTime) ? moment.utc(res.data.header.date + ' ' + res.data.header.startTime).valueOf() : '',
					timestamp: (res.data?.header?.date && res.data?.header?.startTime) ? moment.utc(res.data.header.date + ' ' + res.data.header.startTime).valueOf() : 0,
				}))
				if (entry) {
					setCoordinates({ lat: entry.gps.lat, lng: entry.gps.lon });
					setDir(getDirection(entry.direction));
					setDirection(entry.direction);
					// setTimestamp(entry.ts);
				}
			})
			.catch((error) => {
				console.log('error', error);
			})

		return () => {
			if (intervalPlayback) {
				clearInterval(intervalPlayback);
				setIntervalPlayback(null);
			}
		}
	}, []);

	useEffect(() => {
		// if (value) {
		const ts = value
		const metadataUpdate = metadata;

		let ind = 0;
		const entry = _.find(metadataUpdate, function (item, i) {
			ind = i;
			return (item.t - metadataUpdate[0].t) >= (ts * 1000);
		});

		if (entry) {
			let newSpeed = entry.speed || 0;
			if (!newSpeed) {
				const speed_entry = _.find(metadataUpdate, function (item, i) {
					return ((item.t - metadataUpdate[0].t) >= (ts * 1000 + 1000)) || (item.speed > 0);
				}, ind)

				if (speed_entry) {
					newSpeed = speed_entry.speed || 0;
				} else {
					newSpeed = 0;
				}
			}
			setSpeed(Math.round(newSpeed * 0.62));

			let gps = entry.gps || 0;
			// if (entry.gps && entry.gps.lat && entry.gps.lon) {
			if (!gps) {
				const gps_entry = _.find(metadataUpdate, function (item, i) {
					return ((item.t - metadataUpdate[0].t) >= (ts * 1000 + 500)) || (item.gps);
				}, ind)

				if (gps_entry && gps_entry.gps) {
					setCoordinates({ lat: gps_entry.gps.lat, lng: gps_entry.gps.lon });
					// states.dir = getDirection(entry.direction);
					// states.direction = entry.direction;
				}
			} else {
				setCoordinates({ lat: gps.lat, lng: gps.lon });
				// states.dir = getDirection(entry.direction);
				// states.direction = entry.direction;
				// states.timestamp = entry.ts;
			}

			if (entry.direction) {
				setDir(getDirection(entry.direction));
				setDirection(entry.direction);
			}

			if (header.mobileye) {
				let meye = entry.meye // || meye;
				if (!meye) {
					const meye_entry = _.findLast(metadataUpdate, function (item, i) {
						return /*((item.t - metadataUpdate[0].t) >= (ts*1000+1000)) ||*/ _.has(item, 'meye')
					}, ind)

					if (meye_entry && meye_entry.meye) {
						setMeye(meye_entry.meye.warn)
					}
					else {
						setMeye({
							"error": false,
							"failsafe": false,
							"fcw": false,
							"hw": 0,
							"hwWarning": 0,
							"ldw": true,
							"ldwLeft": false,
							"ldwRight": false,
							"pedDz": false,
							"pedForward": false,
							"speedWarning": 0,
							"tamper": false
						})
					}
				}
			}
		}
	}, [state.timestamp])

	useEffect(() => {
		if (showZoomControls) {
			$(document).mouseup((e) => { if (($('.vjs-zoom__container')[0] && !$('.vjs-zoom__container')[0].contains(e.target)) && !$('.btn-zoom')[0].contains(e.target)) { setShowZoomControls(false) } });
		}
	}, [showZoomControls])

	const hasAudio = (video) => {
		return video.mozHasAudio
			|| Boolean(video.webkitAudioDecodedByteCount)
			|| Boolean(video.audioTracks && video.audioTracks.length);
	}

	const setPlayerEvents = (maxCollection, forcePause) => {

		vid1 = document.getElementById("channel1");
		vid2 = document.getElementById("channel2");
		vid3 = document.getElementById("channel3");
		vid4 = document.getElementById("channel4");

		const player_video = document.getElementById('player-video');

		const obj = _.minBy(maxCollection, o => o.duration);
		// setParentObj(obj)
		player_video.getElementsByTagName('video')[0].addEventListener('ended', function (e) {
			setPlay(false);
		}, false);

		// let pind = 0;
		// obj.videoObj.addEventListener('timeupdate', function(e){
		player_video.getElementsByTagName('video')[0].addEventListener('timeupdate', function (e) {
			// debugger
			const ts = this.currentTime
			setValue(ts)
			// const metadataUpdate = metadata;
			setState((prevState) => ({ ...prevState, timestamp: prevState.starttimestamp + ts * 1000 }));
		}, false);

		toggleLoader(false)

		if (!forcePause) {
			setMax(document.getElementById('player-video').getElementsByTagName('video')[0].duration)
			// FWSD-6409
			// if (!isMobileOnly && !showChannelsSelection) {
			// 	playVideo(false);
			// }
		}
	}

	const toggleAudio = (e, player_number) => {
		e.stopPropagation();

		if (player_number) {
			videos[player_number - 1].audio && setChannelAudio(player_number);
		}
		else {
			setChannelAudio(0)
		}
	}

	const changeActiveChannel = (channelSelected) => {
		stopVideo()
		setActiveChannel(channelSelected)
	}

	const playVideo = (ff) => {
		clearInterval(intervalPlayback);

		if (!play || ff) {
			const playbackRateUpdate = Math.abs(playbackRate);
			setPlay(true);

			let videoSelection = '#player-video video';
			if (showChannelsSelection) {
				videoSelection = '#player-video video#channel' + channelAudio;
			}

			$(videoSelection).each(function (e, a) {
				this.playbackRate = playbackRateUpdate;
				this.play();
			});

			if (videoUrls.length > 1 && !showChannelsSelection) {
				vidDeviationControl();
			}
		} else {
			setPlay(false);

			$('#player-video video').each(function () {
				this.pause();
			});
		}
	}

	const pauseVideo = () => {
		clearInterval(intervalPlayback);
		$('#player-video video').each(function () {
			this.pause();
		});
	}

	const stopVideo = (e) => {
		clearInterval(intervalPlayback);
		$('#player-video video').each(function () {
			this.pause();
		});

		changeVideoSlider(e, 0);

		setPlay(false);
	}

	const changeVideoSlider = (e, newval) => {
		const val = (typeof (newval) != "undefined") ? newval : e.target.value;
		$('#player-video video').each(function () {
			this.currentTime = val;
		});

		setValue(val);
	}

	const downloadNVR = () => {
		if (nvrUrl) {
			addAuditLogFunc('download_nvr', { downloaded: nvrUrl })
			window.location.href = nvrUrl;
		}
	}

	const getVideoSoundIcon = (channelNumber) => {
		const row = videos[channelNumber - 1]

		if (row.audio && channelAudio === channelNumber) {
			return (<CustomButton variant="empty" size="icon" id="sound" onClick={(e) => toggleAudio(e, 0)}>
				{videoPlayerIcons.soundOnIcon}
			</CustomButton >)
		} else if (row.audio) {
			return (<CustomButton variant="empty" size="icon" id="sound" onClick={(e) => toggleAudio(e, channelNumber)}>
				{videoPlayerIcons.soundOffIcon}
			</CustomButton >
			)
		}
	}

	//* Sizing of the popup with player
	let VideoColumnWidth = '80%';
	let MetadataColumnWidth = '20%';
	let PlayerVideoHeight = document.getElementById('player-container') ? document.getElementById('player-container').offsetHeight + 1 : windowHeight;
	let ChannelHeight = document.getElementsByClassName('channel')[0] && document.getElementsByClassName('channel')[0].offsetHeight;
	let MapHeight = document.getElementById('event-info') ? document.getElementById('event-info').offsetHeight + 20 : '50%';
	let WrapperColumns = '50% 50%';

	if (showChannelsSelection) {
		WrapperColumns = '100%';
	}

	if (windowWidth < 800) {
		VideoColumnWidth = '100%';
		MetadataColumnWidth = '100%';
		PlayerVideoHeight = '100%';
	}

	if (isMobileOnly) {
		VideoColumnWidth = '100%';
		MetadataColumnWidth = '100%';
	}
	//******

	const videosLength = videoUrls && videoUrls.length

	const displayTime = (value) => {
		const durationSeconds = Math.floor(value)
		if (durationSeconds > 0) {
			// return moment(Math.floor(value) * 1000).format('mm:ss')
			return moment.duration(durationSeconds, 'seconds').format()
		}
		else {
			return "0:00"
		}
	}

	const video1 = (<div
		className={classnames('channel channel1', { 'active': channelAudio === 1 })}
		onClick={(e) => toggleAudio(e, 1)}
		onDoubleClick={() => changeActiveChannel(1)}
		onMouseOver={() => { if (!single_active_player) { setShowTooltipDoubleClick(true) } }}
		onMouseOut={() => setShowTooltipDoubleClick(false)}
	>
		<h1 style={{ lineHeight: 0 }}>
			{/* <video id="channel1" data-channel="1" muted={channelAudio != 1} preload="auto" playsInline src={videoUrls[0]} muted='muted' /> */}
			{/* <video id="channel1" data-channel="1" preload="auto" playsInline src={videoUrls[0]} muted='muted' /> */}
			<video id="channel1" data-channel="1" muted={channelAudio != 1} preload="auto" playsInline src={videoUrls[0]} />
			{/* {getVideoSoundIcon(1) && <img src={`/images/ico/volume_${getVideoSoundIcon(1)}.svg`} className="sound" />} */}
			{activeChannel !== 1 && getVideoSoundIcon(1)}
		</h1>
	</div>);
	// const video2 = (videoUrls.length > 1) && (
	const video2 = (videosLength > 1) && (
		<div
			className={classnames('channel channel2', { 'active': channelAudio === 2 })}
			onClick={(e) => toggleAudio(e, 2)}
			onDoubleClick={() => changeActiveChannel(2)}
			onMouseOver={() => { if (!single_active_player) { setShowTooltipDoubleClick(true) } }}
			onMouseOut={() => setShowTooltipDoubleClick(false)}
		>
			<h1>
				{/* <video id="channel2" data-channel="2" muted={channelAudio != 2} preload="auto" playsInline src={videoUrls[1]} muted='muted' /> */}
				{/* <video id="channel2" data-channel="2" preload="auto" playsInline src={videoUrls[1]} muted='muted' /> */}
				<video id="channel2" data-channel="2" muted={channelAudio != 2} preload="auto" playsInline src={videoUrls[1]} />
				{/* {getVideoSoundIcon(2) && <img src={`/images/ico/volume_${getVideoSoundIcon(2)}.svg`} className="sound" />} */}
				{activeChannel !== 2 && getVideoSoundIcon(2)}
			</h1>
		</div>);
	// const video3 = (videoUrls.length > 2) ? (
	const video3 = (videosLength > 2) ? (
		<div
			className={classnames('channel channel3', { 'active': channelAudio === 3 })}
			onClick={(e) => toggleAudio(e, 3)}
			onDoubleClick={() => changeActiveChannel(3)}
			onMouseOver={() => { if (!single_active_player) { setShowTooltipDoubleClick(true) } }}
			onMouseOut={() => setShowTooltipDoubleClick(false)}
		>
			<h1>
				{/* <video id="channel3" data-channel="3" muted={channelAudio != 3 ? 'false' : 'muted'} preload="auto" playsInline src={videoUrls[2]} muted='muted' /> */}
				{/* <video id="channel3" data-channel="3" preload="auto" playsInline src={videoUrls[2]} muted='muted' /> */}
				<video id="channel3" data-channel="3" muted={channelAudio != 3} preload="auto" playsInline src={videoUrls[2]} />
				{/* {getVideoSoundIcon(3) && <img src={`/images/ico/volume_${getVideoSoundIcon(3)}.svg`} className="sound" />} */}
				{activeChannel !== 3 && getVideoSoundIcon(3)}
			</h1>
		</div>) :
		<div className='empty-channel' />;
	// const video4 = (videoUrls.length > 3) ? (
	const video4 = (videosLength > 3) ? (
		<div
			className={classnames('channel channel4', { 'active': channelAudio === 4 })}
			onClick={(e) => toggleAudio(e, 4)}
			onDoubleClick={() => changeActiveChannel(4)}
			onMouseOver={() => { if (!single_active_player) { setShowTooltipDoubleClick(true) } }}
			onMouseOut={() => setShowTooltipDoubleClick(false)}
		>
			<h1>
				{/* <video id="channel4" data-channel="4" muted={channelAudio != 4 ? 'false' : 'muted'} preload="auto" playsInline src={videoUrls[3]}  muted='muted' /> */}
				{/* <video id="channel4" data-channel="4" preload="auto" playsInline src={videoUrls[3]} muted='muted' /> */}
				<video id="channel4" data-channel="4" muted={channelAudio != 4} preload="auto" playsInline src={videoUrls[3]} />
				{/* {getVideoSoundIcon(4) && <img src={`/images/ico/volume_${getVideoSoundIcon(4)}.svg`} className="sound" />} */}
				{activeChannel !== 4 && getVideoSoundIcon(4)}
			</h1>
		</div>) :
		<div className='empty-channel' />;

	const getVideoChannel = (position) => {
		switch (activeChannel) {
			case 1:
				if (position === 1) return video1;
				if (position === 2) return video2;
				if (position === 3) return video3;
				if (position === 4) return video4;
				break
			case 2:
				if (position === 1) return video2;
				if (position === 2) return video1;
				if (position === 3) return video3;
				if (position === 4) return video4;
				break
			case 3:
				if (position === 1) return video3;
				if (position === 2) return video1;
				if (position === 3) return video2;
				if (position === 4) return video4;
				break
			case 4:
				if (position === 1) return video4;
				if (position === 2) return video1;
				if (position === 3) return video2;
				if (position === 4) return video3;
				break
		}
	}

	const getMeyePedestrian = () => {
		let arr = []
		if (meye.pedDZ) {
			arr.push(t('dangerZone'))
		}
		if (meye.pedForward) {
			arr.push(t('forward'))
		}

		if (arr.length) {
			return arr.join(', ')
		}

		return t('textNone')
	}

	const getMeyeSystemStatus = () => {
		const arr = []
		if (meye.error) {
			arr.push(t('errorCode') + meye.error)
		}
		if (meye.tamper) {
			arr.push(t('tamper'))
		}
		if (meye.failsafe) {
			arr.push(t('failsafe'))
		}

		if (arr.length) {
			return arr.join(', ')
		}

		return t('good')
	}

	const element = document.getElementsByTagName('video')[0];
	const style = { bottom: '2.53rem', right: '0px' };

	return (
		<div className="modal-body" style={{ height: `${windowHeight}px` }}>
			<div id="advanced-web-player" className='permalink' style={!isMobileOnly ? { height: `calc(${PlayerVideoHeight}px` } : {}}>
				<div className="col-md-9 col-xs-12 col-sm-12 no-padding video-column">

					<div id="player-video" style={{ width: '100%', height: PlayerVideoHeight }}>
						{(videoUrls.length > 0) &&
							<div id='player-container'>
								<div className='channel1-wrapper'>
									<TransformWrapper>
										<Controls
											element={element}
											style={style}
											changeChannel={activeChannel}
											showZoomControls={showZoomControls}
										/>
										<TransformComponent>
											{getVideoChannel(1)}
										</TransformComponent>
									</TransformWrapper>
									{/* Video horizontal scrolling */}
									<div className="video-slider">
										{<CustomButton variant="empty" onClick={(e) => playVideo(false)} id="play" title={t('titlePlay')}>
											{play ? videoPlayerIcons.pauseIcon : videoPlayerIcons.playIcon}
										</CustomButton>}
										<div className='slider-container'>
											<ReactBootstrapSlider
												id="video-slider"
												name="horizontalSliderName"
												value={value}
												max={max}
												min={0}
												step={0.1}
												tooltip="hide"
												change={changeVideoSlider}
											/>
										</div>
										{videos[activeChannel - 1].audio && ((activeChannel === channelAudio) ?
											<svg xmlns="http://www.w3.org/2000/svg" onClick={(e) => toggleAudio(e, 0)} width="3em" height="3em" fill="#fff" className="bi bi-volume-up-fill sound" viewBox="0 0 16 16">
												<path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z" />
												<path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z" />
												<path d="M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z" />
											</svg> :
											<svg xmlns="http://www.w3.org/2000/svg" onClick={(e) => toggleAudio(e, activeChannel)} width="45" height="45" fill="#fff" className="bi bi-volume-off-fill sound" viewBox="0 0 16 16">
												<path d="M10.717 3.55A.5.5 0 0 1 11 4v8a.5.5 0 0 1-.812.39L7.825 10.5H5.5A.5.5 0 0 1 5 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z" />
											</svg>
										)}
										<CustomButton variant="link" prefix="btn-zoom" onClick={() => setShowZoomControls(!showZoomControls)} >
											{videoPlayerIcons.zoomIcon}
										</CustomButton>
									</div>
								</div>
								<div className={classnames('wrapper', { 'single-channel': (videoUrls.length == 1) }, { 'small-width': (windowWidth < 800) })}>
									{getVideoChannel(2)}
									{getVideoChannel(3)}
									{getVideoChannel(4)}
									<div className="tooltipDoubleClick">
										{t('tooltipDoubleClick')}
									</div>
								</div>
							</div>
						}
					</div>

					{showChannelsSelection &&
						<div style={{ textAlign: 'center', marginTop: '10px' }}>
							<ul className="list-inline chanels-list">
								{_.times(videoUrls.length, i =>
									<li key={i}
										className={classnames('list-inline-item', { 'active': activeChannel === (i + 1) })}
									>
										<a href="javascript:void(0)" onClick={() => changeActiveChannel(i + 1)}>
											{i + 1}
										</a>
									</li>
								)}
							</ul>
						</div>
					}
				</div>

				{/* Right sidebar */}
				<div
					className="col-md-3 col-xs-12 col-sm-12 no-padding metadata-column"
					style={{ height: (PlayerVideoHeight || 700) + 'px' }}
				>
					<div id='event-info' className='right-column-info'>
						<div className='player-header'>
							<div className='metadata-header'>
								<span className="vehicle-name" style={{ fontFamily: 'var(--bs-body-font-family)' }}>{header?.vehicle || t('unnamedVehicle')}</span>
								<span className='event-id'>{params?.eventId}</span>
							</div>
						</div>
						<div id="player-metadata">
							<h4 className='category-title' style={{ fontWeight: '200' }}>{t('titleEventInfo')}</h4>
							<ul>
								{event?.type && <li className="eventNameRow">
									<div>
										<span className='metadata-logo'>
											<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
												<path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
												<path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
											</svg>
										</span>
										<span className='header-value'>
											{i18n.t(`constants.eventNames.${eventTypeDetection(event).replace(/\s/g, "_")}`, eventTypeDetection(event))}
										</span>
									</div>
								</li>}
								{header?.date &&
									<li>
										<span className="metadata-logo">
											<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-calendar-event" viewBox="0 0 16 16">
												<path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
												<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
											</svg>
										</span>
										<span className='header-value'>
											{moment.utc(header.date).format("ddd MMM D[,] YY") + ', ' + (state.timestamp ? moment.utc(state.timestamp).format('h:mm:ss A') : '')}
										</span>
									</li>
								}
								{(driver || header?.driver) &&
									<li>
										<span className="metadata-logo">
											<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-person-badge" viewBox="0 0 16 16">
												<path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
												<path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0h-7zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492V2.5z" />
											</svg>
										</span>
										<span className='header-value'>
											{driver || header.driver}
										</span>
									</li>
								}
								<li className='headerSpeedUnit'>
									<span className="metadata-logo">
										<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-speedometer" viewBox="0 0 16 16">
											<path d="M8 2a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.5A.5.5 0 0 1 8 2zM3.732 3.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 8a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 7.31A.91.91 0 1 0 8.85 8.569l3.434-4.297a.389.389 0 0 0-.029-.518z" />
											<path fillRule="evenodd" d="M6.664 15.889A8 8 0 1 1 9.336.11a8 8 0 0 1-2.672 15.78zm-4.665-4.283A11.945 11.945 0 0 1 8 10c2.186 0 4.236.585 6.001 1.606a7 7 0 1 0-12.002 0z" />
										</svg>
									</span>
									<span className='header-value'>
										<p>{speedUnit === 'KPH' ? Math.round(speed * 1.609) : speed}</p> <span className="red-text" style={{ fontSize: '13px' }}>{meye.speedWarning ? "(" + ((meye.speedWarning - 1) * 5) + "-" + (meye.speedWarning * 5) + t('textOverLimit') : ""}</span>
										<Select
											className="speedUnitSelect"
											onChange={(e) => setSpeedUnit(e.value)}
											options={[{ value: 'MPH', label: 'MPH' }, { value: 'KPH', label: 'KPH' }]}
											value={{ value: speedUnit, label: speedUnit }}
										/>
									</span>
								</li>
								<li>
									<span className="metadata-logo">
										<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-stopwatch" viewBox="0 0 16 16">
											<path d="M8.5 5.6a.5.5 0 1 0-1 0v2.9h-3a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5V5.6z" />
											<path d="M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64a.715.715 0 0 1 .012-.013l.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354a.512.512 0 0 1-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3z" />
										</svg>
									</span>
									<span className='header-value'>
										{displayTime(value)} / {displayTime(max)}
									</span>
								</li>
								{event?.event_notes && <li>
									<span className="metadata-logo">
										<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
											<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5L13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
										</svg>
									</span>
									<span className='header-value'>
										{event?.event_notes}
									</span>
								</li>}
							</ul>

							{header?.mobileye &&
								<ul style={{ marginTop: '5px' }}>
									<li><span className="header-item">{t('headerMobileyeInfo')}</span></li>
									<li><span className="header-item">{t('headerHW')}</span><span className={classnames({ 'green-text': meye.hwWarning == 1 }, { 'red-text': meye.hwWarning == 2 })}>{meye.hw / 10} {t('seconds')}</span></li>
									<li><span className="header-item">{t('headerFCW')}</span>{meye.fcw ? t('forward') : t('textNone')}</li>
									<li><span className="header-item">{t('headerLDW')}</span>{meye.ldw ? t('active') : t('inactive')}{meye.ldwLeft ? t('left') : ""}{meye.ldwRight ? t('right') : ""}</li>
									<li><span className="header-item">{t('headerPedestrian')}</span>{getMeyePedestrian()}</li>
									<li><span className="header-item">{t('headerSystemStatus')}</span>{getMeyeSystemStatus()}</li>
								</ul>
							}
						</div>
						<span className="download-buttons">
							<Dropdown
								id="download-menu-dropdown"
								variant="info"
							>
								<Dropdown.Toggle
									// nocaret
									className="btn-batch imageButton downloadButton"
									title={t('titleDownload')}
									style={{ color: '#0071b6', margin: '5px 10px', borderColor: '#0071b6' }}
								>
									<span>{t('titleDownload')}</span>
								</Dropdown.Toggle>
								<Dropdown.Menu
									className="download-menu"
								>
									<span>
										{(videoUrls.length > 0) &&
											< OverlayTriggerNode
												nvrUrl={nvrUrl}
												videoUrls={videoUrls}
											/>
										}

										{nvrUrl &&
											<CustomButton onClick={downloadNVR} style={{ width: '100%' }} title={t('titleDownloadNVR')} prefix="video-player-button">
												{t('titleDownloadNVR')}
											</CustomButton>
										}
									</span>
								</Dropdown.Menu>
							</Dropdown>
						</span>
					</div>
					{/* HERE Map */}
					<div id="player-map" style={{ height: `calc(100% - ${MapHeight}px)` }}>
						<SimpleMapExampleHEREMap
							containerElement={
								<div style={{ height: `100%` }} className='container-element' />
							}
							mapElement={
								<div style={{ height: `100%` }} className='map-element' />
							}
							coordinates={coordinates}
							polyline={polyline}
							direction={direction}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

const mapStateToProps = ({ loader, user }) => ({
	user: user.user,
	loader: loader.loader,
})

const mapDispatchToProps = (dispatch) => {
	return {
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PermalinkVideo);
